import BreadCrumb from 'src/_metronic/layout/components/breadcrumb'
import {useTransactionDetail} from '../hook/transaction'
import {useIntl} from 'react-intl'
import {getDateAndTime} from 'src/feature/bite/helpers/date'
import {useGetTransaction} from '../context/useGetTransaction'
import {useNavigate, useSearchParams} from 'react-router-dom'
import {currency} from 'src/feature/bite/helpers/currency'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import {useState} from 'react'
import {useIsMobile} from 'src/feature/bite/hook/useIsMobile'

function Transaction() {
  const intl = useIntl()
  const {isLoading} = useGetTransaction()
  const {transactionDetail} = useTransactionDetail()
  const data = transactionDetail
  const navigate = useNavigate()
  const [tab, setTab] = useState('summary')

  const [searchParams] = useSearchParams()

  const members = searchParams.get('members')

  /* const purchaseAmount = data?.totalAmount - data?.discountAmount; */
  const purchaseAmount = data?.purchaseAmount
  const fee = data.feeAmount
  /* const paidAmount = purchaseAmount + fee; */
  const paidAmount = data.paidAmount

  const isMobile = useIsMobile()

  const typeColor = (text: string) => {
    let color = 'text-success'

    switch (text) {
      case 'Cancel':
        color = 'text-error'
        break
      case 'Refund':
        color = 'text-refund'
        break
      case 'Sale':
        color = 'text-success'
        break
      case 'SignUp':
        color = 'text-signup'
        break
      case 'Birthday':
        color = 'text-info'
        break
      default:
        color = 'text-success'
        break
    }

    return color
  }

  const productNameControl = (productName: any, value: any) => {
    if (productName === 'Base Product' || productName === 'Base' || productName === 'Welcome') {
      return '-'
    }

    if (!productName) return '-'
    if (!value) return '-'

    return value || '-'
  }

  return (
    <div className='d-flex flex-column flex-root' id='kt_app_root'>
      <>
        <div className='d-flex flex-column-fluid gap-3 align-items-center'>
          <button
            className='btn btn-sm btn-primary'
            onClick={() => {
              if (members) {
                navigate(`/members/${members}?tab=Transaction`, {replace: true})
              } else {
                navigate(isMobile ? '/members' : '/stores', {replace: true})
              }
            }}
          >
            <i className='bi bi-arrow-left'></i>
          </button>
          <BreadCrumb currentPage={intl.formatMessage({id: 'TRANSACTION.DETAIL'})} />
        </div>

        <div className='row mt-9'>
          <div className='col col-lg-12'>
            <div className='card mb-5 mb-xl-10'>
              <div className='card-body pt-9 pb-0'>
                <div className='d-flex flex-wrap flex-sm-nowrap'>
                  <div className='flex-grow-1'>
                    <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                      <div className='d-flex flex-column'>
                        <div className='d-flex align-items-center mb-2'>
                          <a
                            href='#tx-detail'
                            className='text-gray-900 text-hover-primary fs-2 fw-bold me-1'
                          >
                            {intl.formatMessage({id: 'TRANSACTION.DETAIL'})}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold'>
                  <li className='nav-item mt-2'>
                    <a
                      className='nav-link text-active-primary ms-0 me-10 py-5 active'
                      data-bs-toggle='tab'
                      href='#kt_tab_pane_0'
                      onClick={() => setTab('summary')}
                    >
                      {intl.formatMessage({id: 'TRANSACTION.SUMMARY'})}
                    </a>
                  </li>
                  <li className='nav-item mt-2'>
                    <a
                      className='nav-link text-active-primary ms-0 me-10 py-5'
                      data-bs-toggle='tab'
                      href='#kt_tab_pane_1'
                      onClick={() => setTab('product')}
                    >
                      {intl.formatMessage({id: 'TRANSACTION.PRODUCT.DETAIL'})}
                    </a>
                  </li>

                  {/*                   <li className='nav-item mt-2'>
                    <a
                      className='nav-link text-active-primary ms-0 me-10 py-5'
                      data-bs-toggle='tab'
                      href='#kt_tab_pane_2'
                      onClick={() => setTab('discount')}
                    >
                      {intl.formatMessage({id: 'TRANSACTION.DISCOUNT_CAMPAIGNS'})}
                    </a>
                  </li> */}

                  {/*              <li className='nav-item mt-2'>
                    <a
                      className='nav-link text-active-primary ms-0 me-10 py-5'
                      data-bs-toggle='tab'
                      href='#kt_tab_pane_3'
                      onClick={() => setTab('point')}
                    >
                      {intl.formatMessage({id: 'TRANSACTION.POINT.CAMPAING'})}
                    </a>
                  </li> */}

                  {/* <li className='nav-item mt-2'>
                    <a
                      className='nav-link text-active-primary ms-0 me-10 py-5'
                      data-bs-toggle='tab'
                      href='#kt_tab_pane_4'
                      onClick={() => setTab('payment')}
                    >
                      {intl.formatMessage({ id: 'TRANSACTION.PAYMENT.TYPES' })}
                    </a>
                  </li> */}
                </ul>

                <div className='tab-content  py-5' id='myTabContent'>
                  <div className='tab-pane fade show active' id='kt_tab_pane_0' role='tabpanel'>
                    <div className='pt-5'>
                      <div className='row'>
                        <div className='col-6'>
                          <div className='mb-7'>
                            <label className='col-lg-6 fw-semibold text-muted mb-2'>
                              {intl.formatMessage({id: 'TRANSACTION.TRANSACTION_ID'})}

                              <OverlayTrigger
                                trigger='hover'
                                placement='top'
                                overlay={
                                  <Tooltip>
                                    Unique identifier assigned to this specific transaction.
                                  </Tooltip>
                                }
                              >
                                <i className='bi bi-info-circle text-primary ms-1'></i>
                              </OverlayTrigger>
                            </label>

                            <div className='col-lg-6'>
                              <span className='fw-bold fs-6 text-gray-800'>{data.orderId}</span>
                            </div>
                          </div>

                          <div className='mb-7'>
                            <label className='col-lg-6 fw-semibold text-muted mb-2'>
                              {intl.formatMessage({id: 'TRANSACTION.DATE_TIME'})}

                              <OverlayTrigger
                                trigger='hover'
                                placement='top'
                                overlay={
                                  <Tooltip>
                                    The exact date and time when the transaction was completed.
                                  </Tooltip>
                                }
                              >
                                <i className='bi bi-info-circle text-primary ms-1'></i>
                              </OverlayTrigger>
                            </label>

                            <div className='col-lg-6 fv-row'>
                              <span className='fw-semibold text-gray-800 fs-6'>
                                {getDateAndTime(data.date)}
                              </span>
                            </div>
                          </div>

                          <div className='mb-7'>
                            <label className='col-lg-6 fw-semibold text-muted mb-2'>
                              {intl.formatMessage({id: 'TRANSACTION.TRANSACTION_TYPE'})}

                              <OverlayTrigger
                                trigger='hover'
                                placement='top'
                                overlay={
                                  <Tooltip>
                                    Indicates the nature of the transaction, such as a sales or a
                                    refund.
                                  </Tooltip>
                                }
                              >
                                <i className='bi bi-info-circle text-primary ms-1'></i>
                              </OverlayTrigger>
                            </label>

                            <div className='col-lg-6'>
                              <span className={`fw-semibold fs-6 ${typeColor(data.type)}`}>
                                {data.type ? data.type : '-'}
                              </span>
                            </div>
                          </div>
                          <div className='mb-7'>
                            <label className='col-lg-6 fw-semibold text-muted mb-2'>
                              {intl.formatMessage({id: 'TRANSACTION.REFUNDED_AMOUNT'})}
                              <span className='position-relative'>
                                <OverlayTrigger
                                  trigger='hover'
                                  placement='top'
                                  overlay={
                                    <Tooltip>
                                      The amount returned to the member, if a refund was issued.
                                    </Tooltip>
                                  }
                                >
                                  <i className='bi bi-info-circle text-primary ms-1'></i>
                                </OverlayTrigger>
                              </span>
                            </label>

                            <div className='col-lg-6'>
                              <span className='fw-bold text-gray-800'>
                                {data?.type === 'Refund'
                                  ? currency(data?.totalAmount - data?.discountAmount || 0)
                                  : currency(0)}
                              </span>
                            </div>
                          </div>
                          {/*       <div className='mb-7'>
                            <label className='col-lg-6 fw-semibold text-muted mb-2'>
                              {intl.formatMessage({id: 'TRANSACTION.POINT_EARNED'})}
                            </label>

                            <div className='col-lg-6'>
                              <span className='fw-bold fs-6 text-gray-800'>
                                <NumericFormat
                                  value={Number(data?.pointEarned || 0).toFixed(2)}
                                  allowLeadingZeros
                                  thousandSeparator=','
                                  displayType='text'
                                />
                              </span>
                            </div>
                          </div> */}

                          <div className='mb-7'>
                            <label className='col-lg-6 fs-3 fw-semibold mb-2'>
                              {intl.formatMessage({id: 'TRANSACTION.PAID_AMOUNT'})}
                              <span className='position-relative'>
                                <OverlayTrigger
                                  trigger='hover'
                                  placement='top'
                                  overlay={
                                    <Tooltip>
                                      The total amount successfully paid by the member.
                                    </Tooltip>
                                  }
                                >
                                  <i className='bi bi-info-circle text-primary ms-1'></i>
                                </OverlayTrigger>
                              </span>
                            </label>

                            <div className='col-lg-6'>
                              <span className='fw-bold fs-3'>
                                {data?.type !== 'Refund' ? currency(paidAmount) : 0}
                              </span>
                            </div>
                          </div>
                          {/*       <div className='mb-7'>
                            <label className='col-lg-6 fw-semibold text-muted mb-2'>
                              {intl.formatMessage({id: 'MEMBER.DETAIL.PACKAGE.PACKAGE_AMOUNT'})}
                            </label>

                            <div className='col-lg-6'>
                              <span className='fw-bold fs-6 text-gray-800'>
                                <NumericFormat
                                  value={Number(data?.totalAmount || 0).toFixed(2)}
                                  allowLeadingZeros
                                  thousandSeparator=','
                                  displayType='text'
                                />
                              </span>
                            </div>
                          </div> */}
                        </div>
                        <div className='col-6'>
                          <div className='mb-7'>
                            <label className='col-lg-6 fw-semibold text-muted mb-2'>
                              {intl.formatMessage({id: 'TRANSACTION.TOTAL_AMOUNT'})}
                              <span className='position-relative'>
                                <OverlayTrigger
                                  trigger='hover'
                                  placement='top'
                                  overlay={
                                    <Tooltip>
                                      The total amount calculated before any processing fees or
                                      refunds.
                                    </Tooltip>
                                  }
                                >
                                  <i className='bi bi-info-circle text-primary ms-1'></i>
                                </OverlayTrigger>
                              </span>
                            </label>

                            <div className='col-lg-6'>
                              <span className='fw-bold fs-6 text-gray-800'>
                                {currency(data.totalAmount)}
                              </span>
                            </div>
                          </div>

                          {/*  <div className='mb-7'>
                            <label className='col-lg-6 fw-semibold text-muted mb-2'>
                              {intl.formatMessage({id: 'TRANSACTION.DISCOUNT_CAMPAIGN'})}
                              <span className='position-relative'>
                                <OverlayTrigger
                                  trigger='hover'
                                  placement='top'
                                  overlay={
                                    <Tooltip>
                                      {intl.formatMessage({
                                        id: 'TRANSACTION.DISCOUNT_CAMPAIGN_TOOLTIP',
                                      })}
                                    </Tooltip>
                                  }
                                >
                                  <i className='bi bi-info-circle text-primary ms-1'></i>
                                </OverlayTrigger>
                              </span>
                            </label>

                            <div className='col-lg-6'>
                              <span className='fw-bold fs-6 text-gray-800'>
                                {currency(data?.discountAmount)}
                              </span>
                            </div>
                          </div> */}

                          {/*                         <div className='mb-7'>
                            <label className='col-lg-6 fw-semibold text-muted mb-2'>
                              {intl.formatMessage({id: 'TRANSACTION.POINT_REDEEMPTION'})}
                            </label>

                            <div className='col-lg-6'>
                              <span className='fw-bold fs-6 text-gray-800'>
                                <NumericFormat
                                  value={Number(data?.pointReedemption || 0).toFixed(2)}
                                  allowLeadingZeros
                                  thousandSeparator=','
                                  displayType='text'
                                />
                              </span>
                            </div>
                          </div>
 */}
                          <div className='mb-7'>
                            <label className='col-lg-6 fw-semibold text-muted mb-2'>
                              {intl.formatMessage({id: 'TRANSACTION.PURCHASE_AMOUNT'})}
                              <span className='position-relative'>
                                <OverlayTrigger
                                  trigger='hover'
                                  placement='top'
                                  overlay={
                                    <Tooltip>
                                      The amount charged for the purchased product or membership.
                                    </Tooltip>
                                  }
                                >
                                  <i className='bi bi-info-circle text-primary ms-1'></i>
                                </OverlayTrigger>
                              </span>
                            </label>

                            <div className='col-lg-6'>
                              <span className='fw-bold fs-6 text-gray-800'>
                                {/* <NumericFormat
                                  value={Number(purchaseAmount || 0).toFixed(2)}
                                  allowLeadingZeros
                                  thousandSeparator=','
                                  displayType='text'
                                /> */}
                                {currency(purchaseAmount)}
                              </span>
                            </div>
                          </div>

                          <div className='mb-7'>
                            <label className='col-lg-6 fw-semibold text-muted mb-2'>
                              {intl.formatMessage({id: 'TRANSACTION.FEE_AMOUNT'})}
                              <span className='position-relative'>
                                <OverlayTrigger
                                  trigger='hover'
                                  placement='top'
                                  overlay={
                                    <Tooltip>
                                      Service fee applied during payment processing, if applicable.
                                    </Tooltip>
                                  }
                                >
                                  <i className='bi bi-info-circle text-primary ms-1'></i>
                                </OverlayTrigger>
                              </span>
                            </label>

                            <div className='col-lg-6'>
                              <span className='fw-bold text-gray-800'>{currency(fee)}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='tab-pane fade' id='kt_tab_pane_1' role='tabpanel'>
                    <div className='table-responsive'>
                      <table className='table table-striped table-row-dashed fs-6 gy-5 mb-0 mt-5'>
                        <thead>
                          <tr className='fw-bold fs-7 gs-0'>
                            <th className='text-start w-500px'>
                              {intl.formatMessage({id: 'TRANSACTION.POINT.CAMPAIGN.SKU'})}
                            </th>
                            <th className='text-start w-600px'>
                              {intl.formatMessage({id: 'TRANSACTION.PRODUCT.DETAIL.PRODUCT_NAME'})}
                            </th>
                            <th className='text-start w-50px'>
                              {intl.formatMessage({id: 'TRANSACTION.PRODUCT.DETAIL.QUANTITY'})}
                            </th>
                            <th className='text-end w-300px'>
                              {intl.formatMessage({id: 'TRANSACTION.PRODUCT.DETAIL.UNIT_PRICE'})}{' '}
                            </th>
                            <th className='text-end w-300px'>
                              {intl.formatMessage({
                                id: 'TRANSACTION.PRODUCT.DETAIL.DISCOUNTED_PRICE',
                              })}
                            </th>
                            <th className='min-w-50px'></th>
                            {/* <th className='min-w-50px'>{intl.formatMessage({ id: 'TRANSACTION.PRODUCT.DETAIL.DISCOUNT_RATE' })}</th> */}
                            {/* <th className='min-w-50px'>{intl.formatMessage({ id: 'TRANSACTION.PRODUCT.DETAIL.EARNED_POINT' })}</th> */}
                          </tr>
                        </thead>
                        <tbody className='fw-semibold text-gray-600'>
                          {data?.productDetails?.map((item, index) => (
                            <tr key={index}>
                              <td className='text-start w-200px'>
                                {productNameControl(item.productName, item.skuId)}
                              </td>
                              <td className='text-start w-600px'>
                                {productNameControl(item.productName, item.productName)}
                              </td>
                              <td className='text-start w-50px'>
                                {productNameControl(item.productName, item.quantity)}
                              </td>
                              <td className='text-end w-300px'>{currency(item.unitPrice)}</td>
                              <td className='text-end w-300px'>{currency(item.discountedPrice)}</td>
                              {/* <td className='text-start'>{item.discountRate.toFixed(2)}</td> */}
                              {/* <td className='text-start'>{item.discountRate.toFixed(2)}</td> */}
                              <td></td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      {!isLoading && data?.productDetails?.length === 0 && (
                        <div
                          style={{
                            height: '100%',
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginTop: 35,
                            marginBottom: 15,
                          }}
                        >
                          {intl.formatMessage({id: 'NOT_FOUND'})}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className='tab-pane fade' id='kt_tab_pane_2' role='tabpanel'>
                    <div className='table-responsive'>
                      <table className='table align-middle table-striped table-row-dashed fs-6 gy-5 mb-0 mt-5'>
                        <thead>
                          <tr className='text-start fw-bold fs-7 gs-0'>
                            <th className='min-w-150px'>
                              {intl.formatMessage({
                                id: 'TRANSACTION.DISCOUNT.CAMPAIGN.CAMPAIGN_ID',
                              })}
                            </th>
                            <th className='min-w-300px'>
                              {intl.formatMessage({
                                id: 'TRANSACTION.DISCOUNT.CAMPAIGN.CAMPAIGN_NAME',
                              })}
                            </th>
                            <th className='min-w-150px'>
                              {intl.formatMessage({id: 'TRANSACTION.POINT.CAMPAIGN.SKU'})}
                            </th>
                            <th className='min-w-300px'>
                              {intl.formatMessage({
                                id: 'TRANSACTION.DISCOUNT.CAMPAIGN.PRODUCT_NAME',
                              })}
                            </th>
                            <th className='min-w-50px'>
                              {intl.formatMessage({id: 'TRANSACTION.DISCOUNT.CAMPAIGN.QUANTITY'})}
                            </th>
                            <th className='min-w-50px w-250px text-end'>
                              {intl.formatMessage({id: 'TRANSACTION.DISCOUNT.CAMPAIGN.UNIT_PRICE'})}
                            </th>
                            <th className='w-250px text-end'>
                              {intl.formatMessage({
                                id: 'TRANSACTION.DISCOUNT.CAMPAIGN.DISCOUNTED_PRICE',
                              })}
                            </th>
                            {/* <th className='min-w-50px'>{intl.formatMessage({ id: 'TRANSACTION.DISCOUNT.CAMPAIGN.DISCOUNT_RATE' })}(%)</th> */}
                            <th className='w-250px text-end'>
                              {intl.formatMessage({
                                id: 'TRANSACTION.DISCOUNT.CAMPAIGN.COUPON_CODES',
                              })}
                            </th>
                            <th className='w-250px text-end'></th>
                          </tr>
                        </thead>
                        <tbody className='fw-semibold text-gray-600'>
                          {data?.discountCampaigns?.map(
                            (item, index) =>
                              item.campaignID && (
                                <tr key={index}>
                                  <td className='text-start'>{item.campaignID}</td>
                                  <td className='text-start'>{item.campaignName}</td>
                                  {/* <td className='text-start'>{item.skuid}</td>
                                  <td className='text-start'>{item.productName || '-'}</td>
                                  <td className='text-start'>{item.quantity}</td> */}
                                  <td className='text-start'>
                                    {productNameControl(item.productName, item.skuid)}
                                  </td>
                                  <td className='text-start'>
                                    {productNameControl(item.productName, item.productName)}
                                  </td>
                                  <td className='text-start'>
                                    {productNameControl(item.productName, item.quantity)}
                                  </td>
                                  <td className='w-250px text-end'>{currency(item.unitPrice)}</td>
                                  <td className='w-250px text-end'>
                                    {currency(item.discountedPrice)}
                                  </td>
                                  {/* <td className='text-start'>{item.discountedRate.toFixed(2)}</td> */}
                                  <td className='w-250px text-end'>{item?.couponCodes || '-'}</td>
                                  <td className='w-250px text-end'></td>
                                </tr>
                              )
                          )}
                        </tbody>
                      </table>
                      {!isLoading && data?.discountCampaigns?.length === 0 && (
                        <div
                          style={{
                            height: '100%',
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginTop: 35,
                            marginBottom: 15,
                          }}
                        >
                          {intl.formatMessage({id: 'NOT_FOUND'})}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className='tab-pane fade' id='kt_tab_pane_3' role='tabpanel'>
                    <div className='table-responsive'>
                      <table className='table align-middle table-striped table-row-dashed fs-6 gy-5 mb-0 mt-5'>
                        <thead>
                          <tr className='fw-bold fs-7'>
                            <th className='w-50px'>
                              {intl.formatMessage({id: 'TRANSACTION.POINT.CAMPAIGN.CAMPAIGN_ID'})}
                            </th>
                            <th className='w-150px'>
                              {intl.formatMessage({id: 'TRANSACTION.POINT.CAMPAIGN.CAMPAIGN_NAME'})}
                            </th>
                            <th className='w-50px'>
                              {intl.formatMessage({id: 'TRANSACTION.POINT.CAMPAIGN.SKU'})}
                            </th>
                            <th className='w-100px'>
                              {intl.formatMessage({id: 'TRANSACTION.POINT.CAMPAIGN.PRODUCT_NAME'})}
                            </th>
                            <th className='w-50px'>
                              {intl.formatMessage({id: 'TRANSACTION.POINT.CAMPAIGN.POINTS_EARNED'})}
                            </th>
                            <th className='w-50px'>
                              {intl.formatMessage({
                                id: 'TRANSACTION.POINT.CAMPAIGN.POINT_ACTIVATION_DATE',
                              })}
                            </th>
                            {/* <th className='w-50px'>{intl.formatMessage({ id: 'TRANSACTION.POINT.CAMPAIGN.POINT_EXPIRATION_DATE' })}</th> */}
                            <th className='w-50px'>
                              {intl.formatMessage({id: 'TRANSACTION.POINT.CAMPAIGN.TYPE'})}
                            </th>
                            <th className='w-50px'>
                              {intl.formatMessage({id: 'TRANSACTION.POINT.CAMPAIGN.STATUS'})}
                            </th>
                            {/* <th className='w-50px'>{intl.formatMessage({ id: 'TRANSACTION.POINT.CAMPAIGN.DEFERRED_BONUS' })}</th> */}
                          </tr>
                        </thead>
                        <tbody className='fw-semibold text-gray-600'>
                          {data?.pointCampaigns?.map((item, index) => (
                            <tr key={index}>
                              {/* <td className='text-start'>{item.name}</td>
                              <td className='text-start'>{item.skuID}</td> */}
                              <td className='text-start'>{item.campaignID}</td>
                              <td className='text-start'>{item.campaignName}</td>
                              <td className='text-start'>
                                {/* {item.name === 'Base Product' || !item.skuID ? '-' : item.skuID} */}
                                {productNameControl(item?.name || '', item.skuID)}
                              </td>
                              <td className='text-start'>
                                {/* {item.name === 'Base Product' || !item.name ? '-' : item.name} */}
                                {productNameControl(item?.name || '', item.name)}
                              </td>
                              <td className='text-start'>{item.pointsEarned.toFixed(2)}</td>
                              <td className='text-start'>
                                {getDateAndTime(item.pointActivationDate)}
                              </td>
                              {/* <td className='text-start'></td> */}
                              <td className='text-start'>{item.type}</td>
                              <td className='text-start'>
                                <span
                                  className={`badge badge-light-${
                                    item.status === 'Active' ? 'success' : 'danger'
                                  } fw-bolder`}
                                >
                                  {item.status}
                                </span>
                              </td>
                              {/* <td className='text-start'>
                                {item.deferredBonus === 1 ? 'Yes' : 'No'}
                              </td> */}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      {!isLoading && data?.pointCampaigns?.length === 0 && (
                        <div
                          style={{
                            height: '100%',
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginTop: 35,
                            marginBottom: 15,
                          }}
                        >
                          {intl.formatMessage({id: 'NOT_FOUND'})}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className='tab-pane fade' id='kt_tab_pane_4' role='tabpanel'>
                    <div className='table-responsive'>
                      <table className='table table-striped table-row-dashed fs-6 gy-5 mb-0'>
                        <thead>
                          <tr className='fw-bold fs-7 gs-0'>
                            <th className=''>
                              {intl.formatMessage({id: 'TRANSACTION.PAYMENT.TYPES.DATE'})}
                            </th>
                            <th className=''>
                              {intl.formatMessage({id: 'TRANSACTION.PAYMENT.TYPES.PAYMENT_TYPE'})}
                            </th>
                            <th className='w-250px text-end'>
                              {intl.formatMessage({id: 'TRANSACTION.PAYMENT.TYPES.AMOUNT'})}
                            </th>
                            <th className='w-250px text-end'></th>
                          </tr>
                        </thead>
                        <tbody className='fw-semibold text-gray-600'>
                          {data?.paymentTypes?.map((item, index) => (
                            <tr key={index}>
                              <td className=''>{getDateAndTime(item.date)}</td>
                              <td className=''>
                                {item.paymentType === 'Points'
                                  ? 'Point Redemption'
                                  : item.paymentType === 'CreditCard'
                                  ? 'Credit Card'
                                  : item.paymentType}
                              </td>
                              <td className='w-250px text-end'>{currency(item.amount)}</td>
                              <td className='w-250px text-end'></td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      {!isLoading && data?.paymentTypes?.length === 0 && (
                        <div
                          style={{
                            height: '100%',
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginTop: 35,
                            marginBottom: 15,
                          }}
                        >
                          {intl.formatMessage({id: 'NOT_FOUND'})}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {tab === 'summary' && (
              <div className='card'>
                <div className='card-header'>
                  <div className='card-title'>
                    <h3 className='card-label'>
                      {intl.formatMessage({id: 'TRANSACTION.PAYMENT.TYPES'})}
                    </h3>
                  </div>
                </div>
                <div className='card-body'>
                  <div className='table-responsive'>
                    <table className='table table-striped table-row-dashed fs-6 gy-5 mb-0'>
                      <thead>
                        <tr className='fw-bold fs-7 gs-0'>
                          <th className=''>{intl.formatMessage({id: 'LABEL.PAYMENT.DATE'})}</th>

                          <th className='text-start'>
                            {intl.formatMessage({id: 'TRANSACTION.PAYMENT.TYPES.AMOUNT'})}
                          </th>

                          <th className=''>
                            {intl.formatMessage({id: 'CHECKOUT.PURCHASE.TABLE.CHANNEL'})}
                          </th>
                        </tr>
                      </thead>
                      <tbody className='fw-semibold text-gray-600'>
                        {data?.paymentTypes?.map((item, index) => (
                          <tr key={index}>
                            <td className=''>{getDateAndTime(item.date)}</td>
                            <td className='text-start'>{currency(item.amount)}</td>
                            <td className=''>
                              {item.paymentType === 'Points'
                                ? 'Point Redemption'
                                : item.paymentType === 'CreditCard'
                                ? 'Credit Card'
                                : item.paymentType === 'GooglePay'
                                ? 'Google Pay'
                                : item.paymentType === 'ApplePay'
                                ? 'Apple Pay'
                                : item.paymentType}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {!isLoading && data?.paymentTypes?.length === 0 && (
                      <div
                        style={{
                          height: '100%',
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          marginTop: 35,
                          marginBottom: 15,
                        }}
                      >
                        {intl.formatMessage({id: 'NOT_FOUND'})}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </>
    </div>
  )
}

export default Transaction
